import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ApiService} from '../services/api';
import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../services/user-context';
import {MatDialog, MatIconRegistry, MatSnackBar} from '@angular/material';
import {DOCUMENT, TitleCasePipe} from '@angular/common';
import {MDLinkService} from '../services/mdlink/mdlink.service';
import { connect, createLocalTracks, createLocalVideoTrack, createLocalAudioTrack, Room, LocalVideoTrack, LocalDataTrack, LocalAudioTrack, RemoteVideoTrack, RemoteTrack, LocalAudioTrackPublication, LocalParticipant, LocalVideoTrackPublication } from 'twilio-video';
import {HttpClient, HttpParams} from '@angular/common/http';
import {FileViewerDialogComponent} from './components/file-viewer-dialog.component';
import {PrescriptionDialogComponent} from './components/prescription-dialog.component';
import {DomSanitizer} from '@angular/platform-browser';
import {
  DataStateChangeEvent,
  GridComponent,
  GridDataResult,
  RemoveEvent,
  RowArgs,
  SelectionEvent
} from '@progress/kendo-angular-grid';
import {ImageViewerDialogComponent} from './components/image-viewer-dialog.component';
import {GroupDescriptor, State} from "@progress/kendo-data-query";
import {SchedulerEvent} from '@progress/kendo-angular-scheduler';
import * as moment from 'moment';
import {ShopifyService} from '../services/shopify/shopify.service';
import {NoteDialogComponent} from '../clients/components/note-dialog.component';
import {AwsSignatureService} from '../services/auth/aws-signature.service';
import {Observable, Subscription, timer} from 'rxjs';
import {AssetService} from '../services/assets/assets.service';
import {Variant} from '../models/variant.model';
import {Collection} from '../models/collection.model';
import {MatAccordion, MatExpansionPanel} from '@angular/material/expansion';
import {Product} from '../models/product.model';
import {BrandService} from '../services/brand-service/brand.service';
import {AppointmentService} from '../services/appointment/appointment.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TranscriptionService} from '../services/api/transcription.service';
import {TreeViewComponent} from '@progress/kendo-angular-treeview';

@Component({
  selector: 'app-live-session',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'live-session.template.html',
  styleUrls: [
    './live-session.style.scss'
  ],
  styles: [
    "app-live-session .mat-expansion-panel-body {padding:0;}",
    "app-live-session .k-checkbox:not(:checked) {background: #cccccc;opacity: 0.7;border:1px solid #666666;}"
  ]
})
export class LiveSessionComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('videoWindow', { static: true }) videoWindow: ElementRef;
  @ViewChild('localVideoWindow', { static: true }) localVideoWindow: ElementRef;
  @ViewChild('productCatalogGrid',{static:false}) private productGrid:GridComponent;
  @ViewChild('accordian', { static: false }) accordian: MatAccordion;
  @ViewChild('productCatalogPanel', { static: false }) productCatalogPanel: MatExpansionPanel;
  @ViewChild('curatedPanel', { static: false }) curatedPanel: MatExpansionPanel;
  @ViewChild('curatedGrid',{static:false}) private curatedGrid:GridComponent;
  @ViewChild('dealGrid',{static:false}) private dealGrid:GridComponent;
  @ViewChild('curatedTree',{static:false}) private curatedTree:TreeViewComponent;


  public groups: GroupDescriptor[] = [];
  public view: any[];

  public dealGroup: FormGroup;

  private editedRowIndex: number;
  private docClickSubscription: any;
  private isNewDealItem: boolean;

  audioOutputDevice:MediaDeviceInfo;
  audioInputDevice:MediaDeviceInfo;
  videoInputDevice:MediaDeviceInfo;

  audioOutputDevices:MediaDeviceInfo[] = [];
  audioInputDevices:MediaDeviceInfo[] = [];
  videoInputDevices:MediaDeviceInfo[] = [];

  authorizationTimer:Subscription;
  assetSubscription:Subscription;
  transcriptionSubscription: Subscription;

  public productView: Observable<GridDataResult>;

  sessionId: string;
  session: any;
  consumer: any;
  assets:any[] = [];
  curations: any[] = [];
  room: Room;
  muted = false;
  credentials: any;
  client: any;
  isConnected = false;
  notes: any;
  diagnostics: any;
  prescriptions: any;
  terminating = false;
  locallyMuted = false;
  locallyPaused = false;
  fullScreen = false;
  looking = {};
  remoteVideoAttached = false;
  telecart = false;
  localVideoTrack:LocalVideoTrack;
  localAudioTrack:LocalAudioTrack;
  localDataTrack:LocalDataTrack;
  schedulerDate: Date = new Date();
  schedulerEvents: SchedulerEvent[];
  selectedProductKeys:string[] = [];
  productSearchTerm = '';
  selectedProducts:Variant[] = [];
  autoOpen = false;
  showProducts = true;
  cartOpened = false;
  createCart = false;
  selectedCuratedNode: any;
  selectedCuratedLeaf: any;
  selectedCurationKeys: any[] = [];
  expandedCurationKeys: any[] = [];
  selectedCuratedProductKeys:string[] = [];
  selectedCuratedProducts:Product[] = [];
  collection:Collection;
  showingCurated = false;
  appointment:any;
  like = {};
  credit:number;
  requestCredit:boolean;
  enableDeposit = false;
  deposit = 0.0;

  noteTypes: Array<any> = [{
    text: 'Simple',
    type: "simple"
  }, {
    text: 'SOAP',
    type: 'soap'
  }, {
    text: 'Assessment',
    type: 'assessment'
  }, {
    text: 'Consultation',
    type: 'consultation'
  }];

  public notesState: State = {
    skip: 0,
    take: 5
  };
  public diagnosticsState: State = {
    skip: 0,
    take: 5
  };
  public prescriptionsState: State = {
    skip: 0,
    take: 5
  };
  private selectedNote: RowArgs;
  brand:any;
  logo:string;
  dynamic = false;
  deal:any[] = [];


  //private mdlinkUnsubscribe: Subject<void> = new Subject<void>();
  private observer:any;
  private brandSubscription:Subscription;
  private appointmentSubscription: Subscription;

  private isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

  constructor(@Inject(DOCUMENT) private document: Document,
              private route: ActivatedRoute,
              private router: Router,
              public userContext: UserContext,
              private changeDetect: ChangeDetectorRef,
              public dialog: MatDialog,
              private snackBar: MatSnackBar,
              private brandService: BrandService,
              private appointmentService: AppointmentService,
              private assetService: AssetService,
              private transcriptionService: TranscriptionService,
              private aws: AwsSignatureService,
              private mdlinkService: MDLinkService,
              private api: ApiService,
              private shopService: ShopifyService,
              public http: HttpClient,
              public iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer) {


    this.shopService.setShopForCountry(this.userContext.account.country || 'us');
    console.log("Loading products from " + this.userContext.account.country || 'us');
    iconRegistry.addSvgIcon(
      'prescription',
        sanitizer.bypassSecurityTrustResourceUrl('assets/prescription.svg'));

    this.assetSubscription = assetService.subscribe( (asset) => {
      try {
        this.localDataTrack.send(JSON.stringify({"asset":asset}));
        console.log("Published asset to data track.");
      } catch( err ) {
        console.log("Error publishing asset to data track: " + err);
      }
    });

    this.productView = shopService;

    this.brandSubscription = this.brandService.subscribe(brand => {
      if( brand ) {
        this.brand = brand;
        this.logo = this.brand.logo;
      }
    });

    this.appointmentSubscription = this.appointmentService.subscribe(appointment => {
      this.appointment = appointment;
      if( this.appointment && this.appointment.invitation ) {
        this.dynamic = true;
      }
    });

    this.api.get<any[]>( "/curation" ).subscribe((result) => {
      this.curations = result || [];
      this.expandTree("0");
    });
  }


  public ngOnInit(): void {

    navigator.mediaDevices.enumerateDevices().then(devices => {
      devices.forEach( device => {
        console.log("Found device: " + device.kind + " " + device.label);
        if( device.kind === "audiooutput" ) {
          this.audioOutputDevices.push(device);
        } else if( device.kind === "audioinput" ) {
          this.audioInputDevices.push(device);
        } else if( device.kind === "videoinput") {
          this.videoInputDevices.push(device);
        }
      });

      this.audioInputDevice = this.selectDefaultMediaDevice(this.audioInputDevices);
      this.audioOutputDevice = this.selectDefaultMediaDevice(this.audioOutputDevices);
      this.videoInputDevice = this.selectDefaultMediaDevice(this.videoInputDevices);
      //
      //this.audioOutputDevice = devices.find(device => device.kind === 'audiooutput');
    });


    this.sessionId = this.route.snapshot.paramMap.get('id');

    this.snackBar.dismiss();

    this.mdlinkService.connect();

    this.observer = this.mdlinkService.mdLinkSocket
      .subscribe(message => {
        console.log("Live Session received -> " + JSON.stringify(message,null,4));

       // let message = JSON.parse(socketMessage.data);
        if( message["status"] === "end" ) {
          if( this.room ) {
            this.room.disconnect();
          } else {
            this.router.navigate(['telehealth']);
          }
          console.log("Received termination status");
        }
        if( message["status"] === "aborted" ) {
          if( this.room ) {
            this.room.disconnect();
          } else {
            this.router.navigate(['telehealth']);
          }
          console.log("Received termination status");
        }
    });

    this.getSession();
  }

  public buildDealForm = dataItem => new FormGroup({
    'show': new FormControl(dataItem.show),
    'item': new FormControl(dataItem.item, Validators.required),
    'amount': new FormControl(dataItem.amount, Validators.required),
    'quantity': new FormControl(dataItem.quantity, Validators.required)
  });

  public clearDeal() {
    this.deal = [];
    this.assetService.unpublish("deal", this.deal);
  }

  public discountedAmount(lineItem:any):number {
    return parseFloat(lineItem.amount) * lineItem.quantity * (1.0 - lineItem.discount);
  }

  public dealTotal():number {
    return this.deal.reduce( (a,item) => { return a + (item.waived ? 0.0 : (item.discount ? this.discountedAmount(item) : parseFloat(item.amount)))}, 0.0);
  }

  public depositTotal():number {
    return this.deposit ? (this.dealTotal() * this.deposit) : 0.0;
  }

  public ngOnDestroy(): void {
    //this.mdlinkUnsubscribe.next();
    //this.mdlinkUnsubscribe.complete();
    this.observer.unsubscribe();
    this.assetSubscription.unsubscribe();
    this.brandSubscription.unsubscribe();
    this.appointmentSubscription.unsubscribe();

    if( this.transcriptionSubscription ) {
      this.transcriptionService.stopRecording();
      this.transcriptionSubscription.unsubscribe();
    }
  }

  public ngAfterViewInit(): void {
    this.expandTree("0");

    if( this.userContext.accountHasOption('voiceassist') ) {
      this.transcriptionSubscription = this.transcriptionService.subscribe(result => {
        this.processVoiceCommand(result);
      });
      this.transcriptionService.startRecording();
    }
  }


  private findCollection(name: string, prefix:string, nodes:any[]):string {
      for (const [i, n] of (nodes || []).entries()) {
        let currentPrefix = `${prefix}${prefix.length ? "_" : ""}${i}`;
        console.log("Checking " + currentPrefix + " for " + name);
        if( n.type === 'collection') {
          if( n.name.toLowerCase().trim() === name.toLowerCase().trim() ) {
            return currentPrefix;
          }
        } else if( n.type === 'folder') {
          let collectionKey = this.findCollection(name, currentPrefix, n.nodes || []);
          if( collectionKey ) {
            return collectionKey;
          }
        }
      }
      return null;
  }

  private processVoiceCommand(command:string) {
    console.log("Processing command: " + command);
    if( !command ) {
      return;
    }
    if( command.match(/open shopping cart/) ) {
      if( !this.telecart ) {
        this.telecart = true;
        this.telecartChanged(this.telecart);
      }
    } else if( command.match(/send shopping cart/) ) {
      if( this.selectedProducts.length )
        this.sendCart();
      else console.log("Cart empty.");
    } else if( command.match(/remove collection/) ) {
      this.showingCurated = false;
      this.toggleCurated(false);
    } else if( command.match(/open collection (.+)/) ) {
      let matches = command.match(/open collection (.+)/);
      if( matches ) {
        let collectionName = matches[1];
        if( this.curations && this.curations.length ) {
          let collectionKey = this.findCollection(collectionName, "0", this.curations[0].nodes || []);
          if( collectionKey ) {
            console.log("Found collection key at " + collectionKey);
            this.expandTree("0");
            if( !this.telecart ) {
              this.telecart = true;
              this.telecartChanged(this.telecart);
            }
            this.curatedPanel.open();
            this.selectedCurationKeys = [collectionKey];
            let selectedNode = this.curatedTree.itemLookup(collectionKey);
            this.onCurationNodeSelect(selectedNode);
            this.showingCurated = true;
            this.toggleCurated(true);
          }
        }
      }
    }
  }

  public telecartChanged(value:boolean) {
    if( value ) {
      this.changeDetect.detectChanges();
      this.productCatalogPanel.open();
    }
  }

  public depositChanged(value:boolean) {
    if( value ) {
      this.assetService.publish("deposit", this.deposit);
    } else {
      this.assetService.unpublish("deposit", this.deposit);
    }
  }

  public requestCreditChanged(value:boolean) {
    this.assetService.publish("creditRequest", value );
    if(!value) {
      this.credit = 0;
    }
  }

  public createChanged(value:boolean) {
    if( value ) {
      this.createCart = value;
    }
  }
  private selectDefaultMediaDevice( devices: MediaDeviceInfo[] ):MediaDeviceInfo {
    if( !(devices || []).length ) {
      return null;
    }
    let defaultDevice = devices.find(d => {(d.label || "").toLowerCase().includes("default")});
    if( !defaultDevice ) {
      defaultDevice = devices.find(d => {(d.label || "").toLowerCase().includes("built-in")});
    }
    if( !defaultDevice ) {
      defaultDevice = devices[0];
    }
    return defaultDevice;
  }

  public diagnosticsStateChange(state: DataStateChangeEvent): void {
    this.diagnosticsState = state;
    this.diagnostics = {
      data: (this.client.diagnostics || []).slice(this.diagnosticsState.skip, this.diagnosticsState.skip + this.diagnosticsState.take),
      total: (this.client.diagnostics || []).length
    };
  }

  public notesStateChange(state: DataStateChangeEvent): void {
    this.notesState = state;
    this.notes = {
      data: (this.client.notes || []).slice(this.notesState.skip, this.notesState.skip + this.notesState.take),
      total: (this.client.notes || []).length
    };
  }

  public prescriptionsStateChange(state: DataStateChangeEvent): void {
    this.prescriptionsState = state;
    this.prescriptions = {
      data: (this.client.prescriptions || []).slice(this.prescriptionsState.skip, this.prescriptionsState.skip + this.prescriptionsState.take),
      total: (this.client.prescriptions || []).length
    };
  }

  public toggleMute(): void {
    this.muted = !this.muted;
  }

  isLiked(productId:string):boolean {
    return !!this.like[productId];
  }

  isLooking(productId:string):boolean {
    return !!this.looking[productId];
  }

  public curatedFolderKeys(prefix:string, nodes:any[]):string[] {
    let keys:string[] = [];

    for (const [i, n] of (nodes || []).entries()) {
      if( n.type === 'folder') {
        let currentPrefix = `${prefix}${prefix.length ? "_" : ""}${i}`;
        keys.push(currentPrefix);
        keys = keys.concat(this.curatedFolderKeys(currentPrefix, n.nodes || []));
      }
    }

    return keys;
  }

  public expandTree(start?:string): void {
    if( !this.curations || !this.curations.length) {
      return;
    }
    let expanded = [];
    expanded.push(start || this.selectedCuratedLeaf.item.index);
    expanded = expanded.concat(this.curatedFolderKeys(start || this.selectedCuratedLeaf.item.index, (this.selectedCuratedNode || this.curations[0]).nodes || []));
    this.expandedCurationKeys = this.expandedCurationKeys.filter(k => !expanded.includes(k)).concat(expanded);
  }


  public collapseTree(): void {
    this.expandedCurationKeys = this.expandedCurationKeys.filter(k => !k.startsWith(this.selectedCuratedLeaf.item.index));
  }

  public curatedIconForNode(node:any):string {
    if (node.type === 'folder' ) {
      return "folder_open"
    } else if( node.type === 'collection' ) {
      return "shopping_cart"
    } else {
      return "";
    }
  }

  toggleCurated(value:boolean):void {
    if( value && this.selectedCuratedProducts.length) {
      this.like = {};
      this.looking = {};
      this.assetService.publish("collection", this.selectedCuratedProducts );
    } else {
      this.assetService.unpublish( "collection", []);
    }
  }

  onCurationNodeSelect(node:any) {
    this.selectedCuratedLeaf = node;
    this.selectedCuratedNode = node.item.dataItem;
    if( this.selectedCuratedNode.type === 'collection') {
      //inflate

      let map = this.shopService.products.reduce((agg, curr) => {agg[curr.id] = curr; return agg;}, {});
      console.log("Mapping from " + this.shopService.products.length);
      let curatedProducts = [];
      for( const id of this.selectedCuratedNode.items || [] ) {
        console.log("Inflating curated product: " + id);
        let product = map[id];
        if( product ) {
          curatedProducts.push( product );
        }
      }
      this.selectedCuratedProducts = curatedProducts;
      console.log("Showing curated products: " + this.selectedCuratedProducts.length + " " + JSON.stringify(this.selectedCuratedProducts));
      //this.selectedProductKeys = this.selectedCuratedNode.items || [];
    }
    console.log("Node is :" + JSON.stringify(this.selectedCuratedLeaf,null,4));
  }


  public locallyUnpause(): void {
    this.locallyPaused = !this.locallyPaused;
    if(this.localVideoTrack) {
      this.localVideoTrack.enable(!this.locallyPaused);
    }
  }

  public locallyPause(): void {
    this.locallyPaused = !this.locallyPaused;
    if(this.localVideoTrack) {
      this.localVideoTrack.enable(!this.locallyPaused);
    }
  }

  public locallyUnmute(): void {
    this.locallyMuted = !this.locallyMuted;
    if(this.localAudioTrack) {
      this.localAudioTrack.enable(!this.locallyMuted);
    }
  }

  public locallyMute(): void {
    this.locallyMuted = !this.locallyMuted;
    if(this.localAudioTrack) {
      this.localAudioTrack.enable(!this.locallyMuted);
    }
  }

  dealMatches(el, selector):boolean {
    return (el.matches || el.msMatchesSelector).call(el, selector);
  }

  public abort(): void {
    console.log("Hang up");

    this.api.patchTelehealth<any>(`/request`, {action:"abort"}).subscribe(result => {
      if( this.room ) {
        this.room.disconnect();
      } else {
        this.endSession();
      }
      this.snackBar.open(`Disconnected from session.`, null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Error terminating session: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public productStateChange(state: DataStateChangeEvent): void {
    this.productState = state;
    this.getProducts();
  }

  public productState: State = {
    skip: 0,
    take: 5
  };

  public productFilter(inputValue: string): void {
    this.productSearchTerm = inputValue;
    this.productState.skip = 0;
    this.getProducts();
  }

  public getProducts() {
    //this.loading = true;
    const page = this.productState.skip / this.productState.take + 1;
    const limit = this.productState.take;

    this.collapseAll();
    this.shopService.getList(page, limit, this.productSearchTerm, this.collection);
  }
  public collapseAll() {
    for( let i = 0; i < this.productState.take; i++ ) {
      this.productGrid.collapseRow(i);
    }
  }

  public showCart() {
    this.cartOpened = true;
  }

  public closeCart() {
    this.cartOpened = false;
  }

  public resetCart() {
    this.selectedProducts = [];
    this.selectedProductKeys = [];
    this.collapseAll();
  }

  public sendCart() {
    console.log("Generating cart...");

    if( this.dynamic ) {
      this.api.post<any>(`/cart`, {
        user_id: this.userContext.user.user_id,
        picture: this.userContext.user.picture,
        appointment: this.appointment,
        curator: `${this.userContext.user.name} ${this.userContext.user.titles || ''}`.trim(),
        consumer: this.session.consumer,
        deposit: this.deposit,
        deal: this.deal,
        lineItems: this.selectedProducts
      }).subscribe( result => {
        let cart = result;
        if( cart && cart.session ) {
          console.log("Publishing cart");
          this.assetService.publish("cart", cart.session );
          this.resetCart();
          this.snackBar.open('Cart sent successfully.', null, {
            duration: 2000
          });
        }
        console.log("Cart: " + JSON.stringify(cart,null,4));
      });
    } else {
      this.api.postEMR<any>(`${this.credentials.path}/cart`, {
        user_id: this.userContext.user.user_id,
        picture: this.userContext.user.picture,
        appointment: this.appointment,
        curator: `${this.userContext.user.name} ${this.userContext.user.titles || ''}`.trim(),
        consumer: this.session.consumer,
        lineItems: this.selectedProducts
      }).subscribe( result => {
        let cart = result;
        if( cart && cart.session ) {
          console.log("Publishing cart");
          this.assetService.publish("cart", cart.session );
          this.resetCart();
          this.snackBar.open('Cart sent successfully.', null, {
            duration: 2000
          });
        }
        console.log("Cart: " + JSON.stringify(cart,null,4));
      });
    }

  }


  public addDealHandler(): void {
    this.closeEditor();

    this.dealGroup = this.buildDealForm({
      'show': false,
      'item': '',
      'quantity': 1,
      'amount': 0.0
    });
    this.isNewDealItem = true;

    this.dealGrid.addRow(this.dealGroup);
  }

  public addDealItemFromCart($event) {
    this.deal.push({waived:false,show:false, item:$event.product.title, quantity:1, amount:parseFloat($event.price), type:'product', id: $event.id});
  }

  public addAllDealItems() {
    let dealIds = this.deal.map(d => d.id || '0');
    for( const p of this.selectedProducts ) {
      if( !dealIds.includes(p.id)) {
        this.deal.push({
          waived: false,
          show: false,
          item: p.product.title,
          quantity: 1,
          amount: p.price,
          type: 'product',
          id: p.id
        });
      }
    }
  }

  public cellClickHandler({ isEdited, dataItem, rowIndex }): void {
    if (isEdited || (this.dealGroup && !this.dealGroup.valid)) {
      return;
    }

    if (this.isNewDealItem) {
      rowIndex += 1;
    }

    this.saveDealItem();

    this.dealGroup = this.buildDealForm(dataItem);
    this.editedRowIndex = rowIndex;

    this.dealGrid.editRow(rowIndex, this.dealGroup);
  }

  public cancelDealItem(): void {
    this.closeEditor();
  }

  private closeEditor(): void {
    this.dealGrid.closeRow(this.editedRowIndex);

    this.isNewDealItem = false;
    this.editedRowIndex = undefined;
    this.dealGroup = undefined;
  }

  public saveDealItem(): void {
    if (this.isNewDealItem && this.dealGroup) {
      this.deal.push(this.dealGroup.value);
      this.assetService.publish("deal", this.deal);
      this.closeEditor();
    } else if( this.dealGroup) {
      this.deal[this.editedRowIndex] = Object.assign(this.deal[this.editedRowIndex], this.dealGroup.value);
      this.assetService.publish("deal", this.deal);
      //this.deal.splice(this.editedRowIndex,1,this.dealGroup.value);
      this.closeEditor();
    }
  }
  public editDealItem({ isEdited, dataItem, rowIndex }): void {
    this.dealGroup = this.buildDealForm(dataItem);
    this.editedRowIndex = rowIndex;

    this.dealGrid.editRow(rowIndex, this.dealGroup);
  }

  public hideAllDealItems() {
    for( const i of this.deal ) {
      i.show = false;
    }
    this.assetService.publish("deal", this.deal);
  }

  public showAllDealItems() {
    for( const i of this.deal ) {
      i.show = true;
    }
    this.assetService.publish("deal", this.deal);
  }

  public updatedDealItemDetails($event) {
    console.log("Got updated deal item: " + " " + JSON.stringify($event,null,4));
    let rowIndex = $event.index;
    delete $event.index;
    this.deal[rowIndex] = Object.assign(this.deal[rowIndex], $event);
    this.assetService.publish("deal", this.deal);
  }


  public removeDealItem(event:RemoveEvent) {
    this.deal = this.deal.filter( p => p.item !== event.dataItem.item );
    this.assetService.publish("deal", this.deal);
  }

  public removeCartHandler(event:RemoveEvent) {
    console.log("Data changed. " + JSON.stringify(event.dataItem));
    this.selectedProducts = this.selectedProducts.filter( p => p.id !== event.dataItem.id );
    this.assetService.unpublish("product", event.dataItem );
    this.selectedProductKeys = this.selectedProducts.map(p => p.id);
    let dealLength = this.deal.length;
    this.deal = this.deal.filter(p => p.id !== event.dataItem.id);
    if( dealLength !== this.deal.length ) {
      this.assetService.publish("deal", this.deal);
    }
    this.collapseAll();
    if( !this.selectedProductKeys.length) {
      this.closeCart();
    }
  }

  public variantSelected(event:SelectionEvent) {
    let deselected = event.deselectedRows.map(r => r.dataItem.id);
    this.selectedProducts = this.selectedProducts.filter( p => !deselected.includes(p.id) ).concat(event.selectedRows.map( r => r.dataItem));
    this.selectedProductKeys = this.selectedProducts.map(p => p.id);
    event.selectedRows.forEach( (row) => {
      this.assetService.publish("product", row.dataItem, this.autoOpen ? {open:true} : null);
      console.log("Publishing asset");
    });
    event.deselectedRows.forEach( (row) => {
      this.assetService.unpublish("product", row.dataItem );
    });
  }

  public collectionChange(value:Collection) {
    this.collection = value;
    console.log("Changed collection to: " + value.title);
    this.productState = {
      skip: 0,
      take: 5
    };
    this.getProducts();
  }

  public showProductChanged(event:boolean) {
    console.log("Show products changed " + event);
    //this.showProducts = event;
  }

  public autoOpenChanged(event:boolean) {
    console.log("Auto open changed " + event);
    //this.autoOpen = event;
  }

  public viewFile(asset:any) {
    this.http.get<any>(asset.link).subscribe( result => {
      const dialogRef = this.dialog.open(FileViewerDialogComponent, {
        width: '500px',
        data: result
      });
    });
  }

  public prescribe() {
    const dialogRef = this.dialog.open(PrescriptionDialogComponent, {
      width: '500px',
      data: this.session
    });

    dialogRef.afterClosed().subscribe(result => {
      if ( result ) {
        result.provider = this.userContext.user;
        result.providerId = this.userContext.user.reference;
        result.providerName = this.userContext.user.name;
        result.consumer = {
          dob: this.client.dob,
          subject: this.client.name || `${this.client.firstName || ""} ${this.client.lastName || ""}`.trim(),
          credentials: this.credentials
        };
        console.log("Sending prescription: " + JSON.stringify(result, null, 4));
        this.api.postTelehealth<any>(`/sessions/${this.sessionId}/prescribe`, result).subscribe(result => {
          console.log(JSON.stringify(result));

          this.api.postEMR<any>(`${this.credentials.path}/prescription`, result ).subscribe( result => {
            this.snackBar.open('Prescription sent successfully.', null, {
              duration: 2000
            });
            this.getClientFromEMR();
          }, (error) => {
            this.snackBar.open(`Error adding prescription: ${error}`, null, {
              duration: 2000
            });
          });
        }, (error) => {
          this.snackBar.open(`Error sending prescription: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

  public endSession(): void {

    this.isConnected = false;

    try {
      this.detachParticipantTracks(this.room.localParticipant);
      this.room.participants.forEach(this.detachParticipantTracks);

      this.room = null;
    } catch (err) {
      console.log("Error hanging up: " + err);
    }
    this.router.navigate(['telehealth']);
  }

  public hangUp(): void {
    console.log("Hang up");

    try {
      this.api.patchTelehealth<any>(`/request`, {action: "end"}).subscribe(result => {
        if (this.room) {
          console.log("Disconnecting from room.");
          this.room.disconnect();
        } else {
          this.endSession();
        }
        this.snackBar.open(`Disconnected from session.`, null, {
          duration: 2000
        });
      }, (error) => {
        this.snackBar.open(`Error terminating session: ${error}`, null, {
          duration: 2000
        });
        this.endSession();
      });
    } catch( err ) {
      this.endSession();
    }
  }

  get systemDescription(): string {
    return `${navigator.userAgent} ${navigator.vendor}`;
  }

  public getSession(): void {
    this.api.getTelehealth<any>(`/sessions/${this.sessionId}`)
      .subscribe(result => {
        this.session = result;
        //console.log("Found session: " + JSON.stringify(this.session, null, 4));
        this.consumer = this.session.consumer;


        if (this.isSafari) {
          const originalAddEventListener = RTCPeerConnection.prototype.addEventListener;
          RTCPeerConnection.prototype.addEventListener = function addEventListener(event, listener) {
            if ('on' + event in this) {
              this._eventListeners = this._eventListeners || new Map();
              const listeners = this._eventListeners.get(event) || [];
              listeners.push(listener);
              this._eventListeners.set(event, listeners);
              if (typeof this['on' + event] !== 'function') {
                var self = this;
                this['on' + event] = function applyListeners() {
                  var a = arguments;
                  const listeners = self._eventListeners.get(event) || [];
                  listeners.forEach(listener => {
                    try {
                      listener.apply(self, a)
                    } catch (error) {
                      console.error(error)
                    }
                  })
                }
              }
              return
            }
            originalAddEventListener.call(this, event, listener)
          };

          const originalRemoveEventListener = RTCPeerConnection.prototype.removeEventListener;
          RTCPeerConnection.prototype.removeEventListener = function removeEventListener(event, listener) {
            if ('on' + event in this) {
              this._eventListeners = this._eventListeners || new Map();
              const listeners = this._eventListeners.get(event) || [];
              this._eventListeners.set(event, listeners.filter(_listener => _listener !== listener));
              return
            }
            originalRemoveEventListener.call(this, event, listener)
          };
        }


        createLocalTracks({
          audio: { name: 'microphone', deviceId: this.audioInputDevice.deviceId },
          video: { height: 720, frameRate: 24, width: 1280, name: 'camera', facingMode: 'user', deviceId: this.videoInputDevice.deviceId  }
        }).then(localTracks => {


          console.log("Found track " + localTracks.map(d => d.kind));
          localTracks.filter( (track) => track.name === 'camera' ).map( (track) => {
            this.localVideoTrack = track;
            this.localVideoWindow.nativeElement.appendChild(track.attach());
            console.log("Attached local video track");
          });
          localTracks.filter( (track) => track.name === 'microphone' ).map( (track) => {
            this.localAudioTrack = track;
            track.attach();

            console.log("Attached local audio track");
          });

          this.localDataTrack = new LocalDataTrack();
          localTracks.push(this.localDataTrack);

          return connect(this.session.provider_access_token, {
            tracks: localTracks
          });
        }).then(room => {
          this.room = room;
          console.log('Connected to Room:', room.name);

          room.participants.forEach(participant => {
            console.log('Participant "%s" is already connected to the Room', participant.identity );
            this.participantConnected(participant);
          });

          room.on('participantDisconnected', (participant) => {
            console.log("RemoteParticipant '" + participant.identity + "' left the room");
            this.detachParticipantTracks(participant);
          });

          room.on('participantConnected', (participant) => {
            console.log("Joining: '" + participant.identity + "'");
            this.participantConnected(participant);
          });

          room.on('disconnected', room => {
            this.endSession();
          });

          room.on('trackSubscribed', track => {
            if (track.kind === 'audio') {
              const audioElement = track.attach();
              audioElement.setSinkId(this.audioOutputDevice.deviceId).then(() => {
                document.body.appendChild(audioElement);
              });
            }
          });

        });
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
  }

  public audioInputDeviceChanged() {
    console.log("Audio Input changed...");
    createLocalAudioTrack({deviceId: this.audioInputDevice.deviceId})
      .then((t) => {
        const tracks = Array.from(<LocalAudioTrackPublication[]>this.room.localParticipant.audioTracks.values()).map(p => p.track);
        this.room.localParticipant.unpublishTracks(tracks);
        this.detachTracks(tracks);
        this.room.localParticipant.publishTrack(t);
        this.localAudioTrack = t;
        t.attach()
        console.log("Updated local audio track.");
      })
      .catch((error) => {
        console.error("Failed to change audio track: ", error);
      })
  }

  public videoInputDeviceChanged() {
    console.log("Video Input changed...");
    createLocalVideoTrack({deviceId: this.videoInputDevice.deviceId})
      .then((t) => {
        const tracks = Array.from(<LocalVideoTrackPublication[]>this.room.localParticipant.videoTracks.values()).map(p => p.track);
        this.room.localParticipant.unpublishTracks(tracks);
        this.detachTracks(tracks);
        this.room.localParticipant.publishTrack(t);
        this.localVideoTrack = t;
        this.localVideoWindow.nativeElement.appendChild(t.attach());
        console.log("Updated local video track.");
      })
      .catch((error) => {
        console.error("Failed to change video track: ", error);
      })
  }

  public audioOutputDeviceChanged() {
    console.log("Output Audio changed...");
      this.room.participants.forEach( p => {
        p.audioTracks.forEach(t => {
          const audioElement = t.track.attach();
          audioElement.setSinkId(this.audioOutputDevice.deviceId)
            .then(() => {
              console.log("Set sink id for audio track to ", this.audioOutputDevice.deviceId);
            })
            .catch((error) => {
              console.error('Failed to set sink id for ', this.audioOutputDevice.deviceId);
            })
        });
      });
  }

  public getClientFromEMR() {
    this.api.getEMR(this.credentials.path).subscribe(clientResult => {
      this.client = clientResult;
      this.notes = {total:(this.client.notes || []).length, data: (this.client.notes || []).reverse().slice(this.notesState.skip, this.notesState.skip + this.notesState.take)};
      this.diagnostics = {total:(this.client.diagnostics || []).length, data: (this.client.diagnostics || []).reverse().slice(this.diagnosticsState.skip, this.diagnosticsState.skip + this.diagnosticsState.take)};
      this.prescriptions = {total:(this.client.prescriptions || []).length, data: (this.client.prescriptions || []).reverse().slice(this.prescriptionsState.skip, this.prescriptionsState.skip + this.prescriptionsState.take)};
      //console.log("Received client: " + JSON.stringify(this.client, null,4));

      //this.shopService.setShopForCountry(this.client.country || 'us');
      var clientEvents: SchedulerEvent[] = [];
      for( const note of this.client.notes ) {
        clientEvents.push( <SchedulerEvent> {
          title: "Note",
          start: moment(note.time).toDate(),
          end: moment(note.time).add(5, 'minutes').toDate()
        });
      }
      for( const diag of this.client.diagnostics ) {
        console.log("Pushing diagnostic to events");
        clientEvents.push( <SchedulerEvent> {
          title: `Diagnostic: ${(diag.type || "").toUpperCase()}`,
          description: diag.type,
          start: moment(diag.time).toDate(),
          end: moment(diag.time).add(5, 'minutes').toDate()
        });
      }
      for( const scrip of this.client.prescriptions ) {
        clientEvents.push( <SchedulerEvent> {
          title: "Prescription",
          description: scrip.name,
          start: moment(scrip.time).toDate(),
          end: moment(scrip.time).add(5, 'minutes').toDate()
        });
      }
      this.schedulerEvents = clientEvents;

    }, (error) => {
      console.log('Error getting client ' + JSON.stringify(error));
    });
  }

  public handleRemoteVideoTrack(track:RemoteVideoTrack): void {
    console.log(`Attaching remote video track :${track.kind}`);
    this.remoteVideoAttached = true;
    this.videoWindow.nativeElement.appendChild(track.attach());
  }

  public attachTrack(track): void {
    if (track.kind === 'video') {
      this.handleRemoteVideoTrack(track);
    } else if (track.kind === 'audio') {
      track.attach();
    } else if (track.kind === 'data') {
      console.log("Attached remote data track.");
      track.on('message', data => {
        let parsedDataMessage = JSON.parse(data);//String.fromCharCode.apply(null, new Uint8Array(data)));
        console.log("Received parsed message from data track: " + JSON.stringify(parsedDataMessage,null,4));
        if( parsedDataMessage.asset ) {
          let url = new URL(parsedDataMessage.asset);
          let pathComponents = url.pathname.split("/");
          let filename = pathComponents[pathComponents.length - 1];
          let filenameComponents = (filename || "").split(".");
          let extension = filenameComponents.length > 0 ? filenameComponents[filenameComponents.length - 1] : "-";
          let name = filenameComponents.length > 0 ? filenameComponents[0] : "-";
          console.log("Found file: " + filename);
          this.assets.push({link: parsedDataMessage.asset, name: name, type: this.typeOf(extension)})
        } else if( parsedDataMessage.credentials ) {
          this.authorizationTimer.unsubscribe();

          this.credentials = parsedDataMessage.credentials;
          this.aws.credentials = parsedDataMessage.credentials;
          console.log("Received credentials: " + JSON.stringify(this.credentials, null, 4));

          this.getClientFromEMR();
      } else if( parsedDataMessage.creditScore ) {
          this.credit = parsedDataMessage.creditScore;
        this.changeDetect.detectChanges();
      } else if( parsedDataMessage.like ) {
          this.like[parsedDataMessage.like.id] = parsedDataMessage.like.status;
          this.changeDetect.detectChanges();
        } else if( parsedDataMessage.look ) {
          this.looking[parsedDataMessage.look.id] = parsedDataMessage.look.status;
          this.changeDetect.detectChanges();
        } else {
          console.log("Could not handle data message: " + JSON.stringify(parsedDataMessage));
        }
      });
    } else {
      console.log("Ignoring other track.");
    }
  }

  // Attach array of Tracks to the DOM.
  public attachTracks(tracks): void {
    tracks.forEach((track) => {
      this.attachTrack(track);
    });
  }

  private detachTracks(tracks): void {
    tracks.forEach((track) => {
      this.detachTrack(track);
    })
  }

  // Detach given track from the DOM.
  public detachTrack(track): void {
    if( track.detach ) {
      track.detach().forEach((element) => {
        element.remove();
      });
    }
  }

  public trackPublished(publication): void {
    if (publication.isSubscribed) {
      this.attachTrack(publication.track);
    }
    publication.on('subscribed', (track) => {
      console.log('Subscribed to ' + publication.kind + ' track');
      this.attachTrack(track);
    });
    publication.on('unsubscribed', this.detachTrack);
  }

  public trackUnpublished(publication) {
    console.log(publication.kind + ' track was unpublished.');
  }

  public participantConnected(participant): void {
    participant.tracks.forEach((publication) => {
      this.trackPublished(publication);
    });
    participant.on('trackPublished', (publication) => {
      this.trackPublished(publication);
    });
    participant.on('trackUnpublished', this.trackUnpublished);

    if( !this.credentials ) {
      this.authorizationTimer = timer(0, 10000).subscribe(n => {
        if( this.appointment && this.appointment.invitation ) {
          this.authorizationTimer.unsubscribe();
          return;
        }
        this.sendAuthorizationRequest();
      });
    }
    this.isConnected = true;
  }

  public getTracks(participant):any[] {
    return Array.from(participant.tracks.values()).filter( (publication:any) => {
      return publication.track;
    }).map((publication:any) => {
      return publication.track;
    });
  }

  public detachParticipantTracks(participant) {
    let tracks = this.getTracks(participant);
    tracks.forEach(this.detachTrack);
  }

  public sendAuthorizationRequest(): void {
    console.log("Sending authorization request.");
    this.localDataTrack.send(JSON.stringify({"authorize":{credentials:true}}));
  }

  public selectedAsset(event: SelectionEvent) {
    let asset = event.selectedRows[0].dataItem;
    console.log("Selected asset " + JSON.stringify(asset) );
    if( asset.type === "image" ) {
      this.dialog.open(ImageViewerDialogComponent, {
        width: '960px',
        data: asset
      })
    } else if( asset.type === "file" ) {
      this.viewFile(asset);
    }
  }

  public onNoteSelection(event: SelectionEvent) {
    this.selectedNote = event.selectedRows[0];
  }

  public addNote(noteType:any): void {
    const dialogRef = this.dialog.open(NoteDialogComponent, {
      data: {type: noteType.type, live: true},
      closeOnNavigation: false,
      disableClose: true,
      hasBackdrop: false,
      maxWidth: "50vw",
      maxHeight: "95vh",
      width: '700px',//noteType.type === 'simple' ? '400px' : '80%',
      position: {top: "20px", left: "20px"}
    });

    dialogRef.afterClosed().subscribe(note => {

      if ( note ) {

        this.api.postEMR<any>(`${this.credentials.path}/note`, note ).subscribe( result => {
          this.snackBar.open('Note added.', null, {
            duration: 2000
          });
          this.getClientFromEMR();
        }, (error) => {
          this.snackBar.open(`Error adding note: ${error} for ${this.credentials.path}/note`, null, {
            duration: 2000
          });
        });

        if( note.meta.cart ) {
          console.log(`Generating cart with ${this.userContext.user.titles || ''}...`);
          this.api.post<any>(`${this.credentials.path}/cart`, {
            user_id: this.userContext.user.user_id,
            picture: this.userContext.user.picture,
            curator: `${this.userContext.user.name} ${this.userContext.user.titles || ''}`.trim(),
            lineItems: note.meta.products
          }).subscribe( result => {
            let cart = result;
            if( cart && cart.session ) {
              console.log("Publishing cart");
              this.assetService.publish("cart", cart.session );
            }
            console.log("Cart: " + JSON.stringify(cart,null,4));
          });
        }

      }
    });
  }

  public viewNote(): void {
    const dialogRef = this.dialog.open(NoteDialogComponent, {
      width: '700px',
      maxWidth: "50vw",
      maxHeight: "95vh",
      data: this.selectedNote.dataItem
    });

    dialogRef.afterClosed().subscribe(location => {
      this.selectedNote = null;
    });
  }

  public typeOf(extension:string): string {
    if(["jpg","png","gif","jpeg"].includes(extension)) {
      return "image"
    } else if(["mov","avi","mp4"].includes(extension)) {
      return "video"
    } else if(["obj","stl"].includes(extension)) {
      return "obj"
    } else if(["json"].includes(extension)) {
      return "file"
    }
    return "-"
  }

  private configurationToString(a) {
    let configuration = '';
    for ( const key in a ) {
      if (a.hasOwnProperty(key)) {
        configuration += key + ' = ' + a[key] + '; ';
      }
    }
    return configuration;
  }

}
